import loadable from '@loadable/component';

export const GuitarplayerSiteWrapper = loadable(
  () => import(/* webpackChunkName: "guitarplayer-site" */ './GuitarplayerSiteWrapper'),
);
